function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * @ignore
 */
export var Registry = /*#__PURE__*/_createClass(function Registry() {
  _classCallCheck(this, Registry);
  /**
   * Currently running version of amCharts.
   */
  Object.defineProperty(this, "version", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "5.3.7"
  });
  /**
   * List of applied licenses.
   * @ignore
   */
  Object.defineProperty(this, "licenses", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: []
  });
  /**
   * Entities that have their `id` setting set.
   */
  Object.defineProperty(this, "entitiesById", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {}
  });
  /**
   * All created [[Root]] elements.
   */
  Object.defineProperty(this, "rootElements", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: []
  });
});
/**
    * @ignore
 */
export var registry = new Registry();
/**
 * Adds a license, e.g.:
 *
 * ```TypeScript
 * am5.addLicense("xxxxxxxx");
 * ```
 * ```JavaScript
 * am5.addLicense("xxxxxxxx");
 * ```
 *
 * Multiple licenses can be added to cover for multiple products.
 *
 * @param  license  License key
 */
export function addLicense(license) {
  registry.licenses.push(license);
}
/**
 * Disposes all [[Root]] elements.
 */
export function disposeAllRootElements() {
  var root;
  while (root = registry.rootElements.pop()) {
    root.dispose();
  }
}